import i18n from '@/plugins/i18n';

export const subTypes = {
  LAMBDA: 'LAMBDA',
  INGRESS: 'ELB',
};

export const subscriptionOverviewHeader = () => [
  {
    key: 'rds_database_connections',
    name: i18n.global.t('aws.rdsOverviewScreen.overviewTable.noOfDbConnection'),
    valueType: 'sum',
    tooltip: i18n.global.t('aws.rdsOverviewScreen.tooltips.noOfDbConnection'),
  },
  {
    key: 'rds_free_storage_space',
    name: i18n.global.t('aws.rdsOverviewScreen.overviewTable.freeStorageSpace'),
    valueType: 'sum',
    tooltip: i18n.global.t('aws.rdsOverviewScreen.tooltips.freeStorageSpace'),
  },
  {
    key: 'rds_cpu_utilization',
    name: i18n.global.t('aws.rdsOverviewScreen.overviewTable.cpuUtilisation'),
    valueType: 'avg',
    tooltip: i18n.global.t('aws.rdsOverviewScreen.tooltips.cpuUtilisation'),
  },
  {
    key: 'rds_read_iops',
    name: i18n.global.t('aws.rdsOverviewScreen.overviewTable.readI'),
    valueType: 'avg',
    tooltip: i18n.global.t('aws.rdsOverviewScreen.tooltips.readI'),
  },
  {
    key: 'rds_write_iops',
    name: i18n.global.t('aws.rdsOverviewScreen.overviewTable.writeI'),
    valueType: 'avg',
    tooltip: i18n.global.t('aws.rdsOverviewScreen.tooltips.writeI'),
  },
];

export const databaseOverviewHeader = () => [
  {
    key: 'rds_database_connections',
    name: i18n.global.t(
      'aws.rdsSubscriptionScreen.instancesTable.noOfDbConnection',
    ),
    valueType: 'avg',
    tooltip: i18n.global.t(
      'aws.rdsSubscriptionScreen.tooltips.noOfDbConnection',
    ),
  },
  {
    key: 'rds_free_storage_space',
    name: i18n.global.t(
      'aws.rdsSubscriptionScreen.instancesTable.freeStorageSpace',
    ),
    valueType: 'avg',
    tooltip: i18n.global.t(
      'aws.rdsSubscriptionScreen.tooltips.freeStorageSpace',
    ),
  },
  {
    key: 'rds_cpu_utilization',
    name: i18n.global.t(
      'aws.rdsSubscriptionScreen.instancesTable.cpuUtilisation',
    ),
    valueType: 'avg',
    tooltip: i18n.global.t('aws.rdsSubscriptionScreen.tooltips.cpuUtilisation'),
  },
  {
    key: 'rds_read_iops',
    name: i18n.global.t('aws.rdsSubscriptionScreen.instancesTable.readI'),
    valueType: 'avg',
    tooltip: i18n.global.t('aws.rdsSubscriptionScreen.tooltips.readI'),
  },
  {
    key: 'rds_write_iops',
    name: i18n.global.t('aws.rdsSubscriptionScreen.instancesTable.writeI'),
    valueType: 'avg',
    tooltip: i18n.global.t('aws.rdsSubscriptionScreen.tooltips.writeI'),
  },
];

export const alertTableHeaderForSubscriptionByAlerts = () => [
  {
    name: i18n.global.t('aws.connectionName'),
    key: 'subscriptionId',
  },
  {
    name: i18n.global.t('aws.alerts'),
    key: 'alerts',
  },
];

export const alertTableHeaderForMetricsByAlerts = () => [
  {
    key: 'metrics',
    name: i18n.global.t('aws.metrics'),
  },
  {
    key: 'alerts',
    name: i18n.global.t('aws.alerts'),
  },
];

export const alertTableHeaderForDbByConnections = () => [
  {
    key: 'instanceId',
    name: i18n.global.t('aws.instanceId'),
  },
  {
    key: 'connections',
    name: i18n.global.t('aws.connections'),
  },
];

export const alertTableHeaderForInvocatedFunctions = () => [
  {
    key: 'functionName',
    name: i18n.global.t('aws.functions'),
  },
  {
    key: 'numberOfInvocations',
    name: i18n.global.t('aws.#invocated'),
  },
];

export const alertTableHeaderForErrorFunctions = () => [
  {
    key: 'functionName',
    name: i18n.global.t('aws.functions'),
  },
  {
    key: 'numberOfErrors',
    name: i18n.global.t('aws.#errors'),
  },
];

export const alertTableToggleOptionsSubscriptionPage = () => [
  i18n.global.t('aws.top10DbByConnetionName'),
  i18n.global.t('aws.top10DbByAlerts'),
];

export const alertTableToggleOptions = () => [
  i18n.global.t('aws.top10AlertsBySubscription'),
  i18n.global.t('aws.top10AlertsByDBInstances'),
];

export const alertTableLambdaSubscriptionToggleOptions = () => [
  i18n.global.t('aws.errorFunctions'),
  i18n.global.t('aws.invocatedFunctions'),
];

export const lambdaOverviewHeader = () => [
  {
    key: 'lambda_function_count',
    tileName: i18n.global.t('aws.totalFunctions'),
    name: i18n.global.t('aws.totalFunctions'),
    valueType: 'instanceCount',
    value: 'instanceCount',
    tooltip: i18n.global.t('aws.serviceTotalFunctionsForTooltip'),
  },
  {
    key: 'lambda_cpu_total_time',
    tileName: i18n.global.t('aws.avgCpuUsage'),
    name: i18n.global.t('aws.cpuTotalTime'),
    valueType: 'avgofavg',
    value: 'avg',
    tooltip: i18n.global.t('aws.serviceAverageCpuTotalTimeForTooltip'),
  },
  {
    key: 'lambda_invocations',
    tileName: i18n.global.t('aws.totalExecutions'),
    name: i18n.global.t('aws.#executions'),
    valueType: 'sumofsum',
    value: 'sum',
    tooltip: i18n.global.t('aws.serviceTotalExecutionsForTooltip'),
  },
  {
    key: 'lambda_errors',
    tileName: i18n.global.t('aws.totalErrors'),
    name: i18n.global.t('aws.#errors'),
    valueType: 'sumofsum',
    value: 'sum',
    tooltip: i18n.global.t('aws.serviceTotalErrorsForTooltip'),
  },
  {
    key: 'lambda_memory_utilization',
    tileName: i18n.global.t('aws.avgMemoryUsage'),
    name: i18n.global.t('aws.avgMemoryUsage'),
    valueType: 'avgofavg',
    value: 'avg',
    tooltip: i18n.global.t('aws.serviceAverageMemoryUsageForTooltip'),
  },
  {
    key: 'lambda_duration',
    tileName: i18n.global.t('aws.averageDuration'),
    name: i18n.global.t('aws.averageDuration'),
    valueType: 'avgofavg',
    value: 'avg',
    tooltip: i18n.global.t('aws.serviceAverageDurationForTooltip'),
  },
];

export const lambdaSubscriptionHeader = () => [
  {
    key: 'lambda_function_count',
    tileName: i18n.global.t('aws.totalFunctions'),
    name: i18n.global.t('aws.totalFunctions'),
    valueType: 'instanceCount',
    value: 'instanceCount',
    tooltip: i18n.global.t('aws.functionTotalFunctionsForTooltip'),
  },
  {
    key: 'lambda_cpu_total_time',
    tileName: i18n.global.t('aws.avgCpuUsage'),
    name: i18n.global.t('aws.cpuTotalTime'),
    valueType: 'avgofavg',
    value: 'avg',
    tooltip: i18n.global.t('aws.functionAverageCpuTotalTimeForTooltip'),
  },
  {
    key: 'lambda_invocations',
    tileName: i18n.global.t('aws.totalExecutions'),
    name: i18n.global.t('aws.#executions'),
    valueType: 'sumofsum',
    value: 'sum',
    tooltip: i18n.global.t('aws.functionTotalExecutionsForTooltip'),
  },
  {
    key: 'lambda_errors',
    tileName: i18n.global.t('aws.totalErrors'),
    name: i18n.global.t('aws.#errors'),
    valueType: 'sumofsum',
    value: 'sum',
    tooltip: i18n.global.t('aws.functionTotalErrorsForTooltip'),
  },
  {
    key: 'lambda_memory_utilization',
    tileName: i18n.global.t('aws.avgMemoryUsage'),
    name: i18n.global.t('aws.memoryUsage'),
    valueType: 'avgofavg',
    value: 'avg',
    tooltip: i18n.global.t('aws.functionAverageMemoryUsageForTooltip'),
  },
  {
    key: 'lambda_duration',
    tileName: i18n.global.t('aws.averageDuration'),
    name: i18n.global.t('aws.totalDuration'),
    valueType: 'avgofavg',
    value: 'avg',
    tooltip: i18n.global.t('aws.functionAverageDurationForTooltip'),
  },
];

export const lambdaOverviewTableHeader = () => [
  {
    key: 'subscriptionId',
    name: i18n.global.t('aws.connectionName'),
  },
];

export const lambdaSubscriptionTableHeader = () => [
  {
    key: 'lambda_invocations',
    tileName: i18n.global.t('aws.#invocations'),
    name: i18n.global.t('aws.#invocations'),
    valueType: 'avg',
  },
  {
    key: 'lambda_cpu_total_time',
    tileName: i18n.global.t('aws.cpuTotalTime'),
    name: i18n.global.t('aws.cpuTotalTime'),
    valueType: 'avg',
  },
  {
    key: 'lambda_memory_utilization',
    tileName: i18n.global.t('aws.memoryUsage'),
    name: i18n.global.t('aws.memoryUsage'),
    valueType: 'sum',
  },
  {
    key: 'lambda_cold_starts',
    tileName: i18n.global.t('aws.coldSarts'),
    name: i18n.global.t('aws.coldSarts'),
    valueType: 'sum',
  },
  {
    key: 'lambda_estimated_cost',
    tileName: i18n.global.t('aws.totalCost'),
    name: i18n.global.t('aws.totalCost'),
    valueType: 'avg',
  },
];

export const alertsMapper = {
  rds_cpu_utilization: 'cpuUtilization',
  rds_read_iops: 'readIops',
  rds_write_iops: 'writeIops',
  rds_disk_queue_depth: 'diskQueueDepth',
  rds_read_latency: 'readLatency',
  rds_write_latency: 'writeLatency',
  rds_freeable_memory: 'freeableMemory',
  rds_swap_usage: 'swapUsage',
  rds_free_storage_space: 'freeStorageSpace',
  rds_network_receive_throughput: 'networkReceiveThroughput',
  rds_network_transmit_throughput: 'networkTransmitThroughput',
  rds_database_connections: 'databaseConnections',
  rds_replica_lag: 'replicaLag',
  rds_bin_log_disk_usage: 'binLogDiskUsage',
  rds_write_throughput: 'writeThroughput',
  rds_read_througput: 'readThroughput',
  lambda_errors: 'lambdaErrors',
  lambda_duration: 'lambdaDuration',
  lambda_memory_utilization: 'lambdaMemoryUsage',
  lambda_invocations: 'lambdaInvocations',
  lambda_concurrent_executions: 'lambdaConcurrentExecutions',
  lambda_iterator_age: 'lambdaIteratorAge',
  lambda_dead_letter_errors: 'lambdaDeadLetterErrors',
  lambda_throttles: 'lambdaThrottles',
  lambda_estimated_cost: 'lambdaEstimatedCost',
  lambda_init_duration: 'lambdaInitDuration',
  lambda_cold_starts: 'lambdaColdStarts',
  lambda_function_count: 'lambdaFunctionCount',
  lambda_cpu_total_time: 'lambdaCpuTotalTime',
  cluster_eca_host_swap_usage: 'hostSwapUsage',
  cluster_eca_host_cluster_count: 'hostClusterCount',
  cluster_eca_host_node_count: 'hostNodeCount',
  cluster_eca_host_each_cluster_node_count: 'hostNodeCount',
  cluster_eca_host_memory_available: 'hostMemoryAvailable',
  cluster_eca_host_cpu_utilization: 'hostCpuUtilization',
  cluster_eca_host_network_bytes_in: 'hostNetworkBytesIn',
  cluster_eca_host_network_bytes_out: 'hostNetworkBytesOut',
  cluster_eca_redis_engine_cpu_utilization_by_node:
    'redisEngineCpuUtilizationByNode',
  cluster_eca_redis_cache_misses_by_node: 'redisCacheMissesByNode',
  cluster_eca_redis_cpu_utilization: 'redisCpuUtilization',
  cluster_eca_redis_database_memory_usage_percentage:
    'redisDatabaseMemoryUsage',
  cluster_eca_redis_replication_bytes: 'redisReplicationBytes',
  cluster_eca_redis_new_connections: 'redisNewConnections',
  cluster_eca_redis_evictions: 'redisEvictions',
  cluster_eca_redis_bytes_used_for_cache_by_node:
    'redisBytesUsedForCacheByNode',
  cluster_eca_redis_cache_hit_rate_by_node: 'redisCacheHitRateByNode',
  cluster_eca_memc_cache_miss_rate_by_node: 'memcCacheMissRateByNode',
  cluster_eca_redis_current_connections: 'redisCurrentConnections',
  cluster_eca_memc_bytes_used_for_hash: 'memcBytesUsedForHash',
  cluster_eca_memc_cas_hit_rate_by_node: 'memcCasHitRateByNode',
  cluster_eca_memc_get_command_by_node: 'memcGetCommandByNode',
  cluster_eca_memc_set_command_by_node: 'memcSetCommandByNode',
  cluster_eca_memc_cas_miss_rate_by_node: 'memcCacheMissRateByNode',
  cluster_eca_memc_current_connections: 'memcCurrentConnections',
  cluster_eca_memc_get_commands: 'memcGetCommands',
  cluster_eca_memc_set_commands: 'memcSetCommands',
  cluster_eca_memc_config_get_commands: 'memcConfigGetCommands',
  cluster_eca_memc_config_set_commands: 'memcConfigSetCommands',
  cluster_eca_memc_new_connections: 'memcNewConnections',
  cluster_eca_memc_cpu_utilization: 'memcCpuUtilization',
  cluster_eca_memc_evictions: 'memcEvictions',
  elb_alb_healthy_host_count: 'albHealthyHostCount',
  elb_alb_unhealthy_host_count: 'albUnhealthyHostCount',
  elb_alb_total_request_count: 'albTotalRequestCount',
  elb_alb_target_response_time: 'albTargetResponseTime',
  elb_alb_active_connection_count: 'albActiveConnectionCount',
  elb_alb_processed_bytes: 'albProcessedBytes',
  elb_alb_rejected_request_count: 'albRejectedRequestCount',
  elb_alb_http_fixed_response_count: 'albHttpFixedResponseCount',
  elb_alb_2xx_count: 'alb2xxCount',
  elb_alb_3xx_count: 'alb3xxCount',
  elb_alb_4xx_errors: 'alb4xxErrors',
  elb_alb_5xx_errors: 'alb5xxErrors',
  elb_alb_errors: 'albErrors',
  elb_nlb_healthy_host_count: 'nlbHealthyHostCount',
  elb_nlb_unhealthy_host_count: 'nlbUnhealthyHostCount',
  elb_nlb_rejected_request_count: 'nlbRejectedRequestCount',
  elb_nlb_errors: 'nlbErrors',
  elb_nlb_port_allocation_error: 'nlbPortAllocationError',
  elb_nlb_client_tls_negotiation_error_count:
    'nlbClientTlsNegotiationErrorCount',
  elb_nlb_target_tls_negotiation_error_count:
    'nlbTargetTlsNegotiationErrorCount',
  elb_nlb_processed_bytes: 'nlbProcessedBytes',
  elb_nlb_active_flow_count: 'nlbActiveFlowCount',
  elb_clb_healthy_host_count: 'clbHealthyHostCount',
  elb_clb_unhealthy_host_count: 'clbUnhealthyHostCount',
  elb_clb_total_request_count: 'clbTotalRequestCount',
  elb_clb_active_connection_count: 'clbActiveConnectionCount',
  elb_clb_estimated_processed_bytes: 'clbEstimatedProcessedBytes',
  elb_clb_latency: 'clbLatency',
  elb_clb_errors: 'clbErrors',
  elb_clb_rejected_request_count: 'clbRejectedRequestCount',
  elb_clb_2xx_count: 'clb2xxCount',
  elb_clb_3xx_count: 'clb3xxCount',
  elb_clb_4xx_errors: 'clb4xxErrors',
  elb_clb_5xx_errors: 'clb5xxErrors',
};

export const overviewSearchSelectOptions = [
  {
    value: 'mysql',
    label: i18n.global.t('aws.mySql'),
  },
  {
    value: 'mssql',
    label: i18n.global.t('aws.msSql'),
  },
  {
    value: 'postgres',
    label: i18n.global.t('aws.postgres'),
  },
];

export const dbTypes = {
  mysql: 'RDS_MYSQL',
  mssql: 'RDS_MSSQL',
  postgres: 'RDS_POSTGRES',
};

export const alertTableType = {
  subscription: 'subscription',
  instance: 'instance',
  lambda_subscription: 'lambda_subscription',
};

export const addToDashboardRadioGroupOptions = [
  {
    value: 'existingDashboard',
    label: i18n.global.t('aws.existingDashboard'),
  },
  { value: 'newDashboard', label: i18n.global.t('aws.newDashboard') },
];

export const rdsServiceCreateEditFormRadioGroupOptions = [
  { value: 'AND', label: i18n.global.t('aws.and') },
  { value: 'OR', label: i18n.global.t('aws.or') },
];

export const overviewTabsradioGroupOptions = () => [
  {
    value: 'tableView',
    label: i18n.global.t('k8.tableView'),
  },
  {
    value: 'graphView',
    label: i18n.global.t('k8.mapView'),
  },
];

export const fileNameMapper = {
  subscriptionId: i18n.global.t('aws.subscriptionData'),
  databaseId: i18n.global.t('aws.databaseData'),
  requestId: i18n.global.t('aws.invocations'),
  functions: i18n.global.t('aws.allFunctions'),
};

export const showDataInGb = () => {
  return {
    service_rds_free_storage_space: 'service_rds_free_storage_space',
    rds_free_storage_space: 'rds_free_storage_space',
  };
};

export const subTypesWithTabs = [
  {
    subType: 'ELASTICACHE',
    page: 'subscriptionId',
  },
  {
    subType: 'INGRESS',
    page: 'subscriptionId',
  },
];

export const CloudActionState = 'cloudState/detail';
export const Time = 'Time';
